import React, { ComponentType, useCallback, useRef, useState } from 'react';
import { useIntl } from 'react-intl';
import { useDispatch, useSelector } from 'react-redux';

import {
  Avatar,
  Box as RawBox,
  BoxProps,
  ButtonBase,
  Menu,
  MenuItem,
  PopoverOrigin,
} from '@mui/material';
import { theme } from '@provider-portal/common/styles/themeMui';

import { logoutAsync } from '@bolteu/redux-session';

import { selectAccountDetails } from 'rdx/account/selectors';

// material ui missed ref type for this component
const Box: ComponentType<BoxProps & { ref?: React.MutableRefObject<any> }> = RawBox;

const anchorOrigin: PopoverOrigin = {
  vertical: 'bottom',
  horizontal: 'center',
};

const avatarStyle = {
  color: theme.palette.primary.contrastText,
  backgroundColor: theme.palette.primary.main,
};

const Account = () => {
  const intl = useIntl();
  const ref = useRef(null);
  const dispatch = useDispatch();
  const [isOpen, setOpen] = useState(false);

  const account = useSelector(selectAccountDetails);

  const handleOpen = useCallback(() => {
    setOpen(true);
  }, []);

  const handleClose = useCallback(() => {
    setOpen(false);
  }, []);

  const handleLogout = useCallback(() => {
    dispatch(logoutAsync.request({ shouldResetToken: true }));
  }, [dispatch]);

  return (
    <Box data-testid={$tid.components.Account.View}>
      <Box
        display="flex"
        alignItems="center"
        component={ButtonBase}
        onClick={handleOpen}
        ref={ref}
        data-testid={$tid.components.Account.DropdownBtn}
      >
        <Avatar alt={account.user.avatar} sx={avatarStyle}>
          {account.user.avatar}
        </Avatar>
      </Box>
      <Menu
        anchorOrigin={anchorOrigin}
        keepMounted
        anchorEl={ref.current}
        open={isOpen}
        onClose={handleClose}
        data-testid={$tid.components.Account.Menu}
      >
        <MenuItem data-testid={$tid.components.Account.LogoutBtn} onClick={handleLogout}>
          {intl.formatMessage({ id: 'components.TopBar.logout' })}
        </MenuItem>
      </Menu>
    </Box>
  );
};

export default Account;
